<div class="dialog-top">
  <h2 mat-dialog-title>{{ 'Versions' | translate }}</h2>
  <button mat-icon-button mat-dialog-close tabindex="-1" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dialog-content">
  <table mat-table [dataSource]="dataSource" matSort matSortActive="updatedDate" matSortDirection="desc">

    <!-- Date Column -->
    <ng-container matColumnDef="updatedDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'Date' | translate }}
      </th>
      <td mat-cell *matCellDef="let page">
        {{ page.updatedDate | date:'dd/MM/yyyy HH:mm:ss' }}
      </td>
    </ng-container>

    <!-- Version Column -->
    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'Version' | translate }}
      </th>
      <td mat-cell *matCellDef="let page">
        <span [innerHTML]="VersionBoldIndex(page.version)"></span>
        <b *ngIf="page.current"> ({{ 'Current' | translate }})</b>
      </td>
    </ng-container>


    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let page" class="">
        <div matTooltip="{{ 'Restore' | translate }}">
          <button mat-icon-button (click)="restorePage(page)">
            <mat-icon>swap_horiz</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let tag; columns: displayedColumns" class="table-row"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="99">{{ 'No items to display' | translate }}</td>
    </tr>
  </table>
  <mat-paginator [length]="totalItems" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" [showFirstLastButtons]="true"></mat-paginator>
</mat-dialog-content>
